import { render, staticRenderFns } from "./PasswordUpdater.vue?vue&type=template&id=165da010&scoped=true&"
import script from "./PasswordUpdater.vue?vue&type=script&lang=js&"
export * from "./PasswordUpdater.vue?vue&type=script&lang=js&"
import style0 from "./PasswordUpdater.vue?vue&type=style&index=0&id=165da010&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165da010",
  null
  
)

export default component.exports